import React, { useState, useCallback, useEffect } from "react";
import { Button } from "antd";
// import { toast } from "react-hot-toast";
import CustomSelect from "../../../components/Elements/Select/CustomSelect";
import CustomDatePicker from "../../../components/Elements/CustomDatePicker/CustomDatePicker";
import { getApi, postApi } from "../../../api/api_instance";
import { API_URLS } from "../../../api/apiUrls";
import CustomButton from "../../../components/Elements/Buttons/CustomButtons";
import moment from "moment";
import PopupCard from "../../../components/Cards/PopupCard/PopupCard";

const AssignedForm = ({
  projectId,
  selectedRows,
  assignedFormType,
  selectedRole,
  clientId,
  setSelectedRole,
  formId,
  setFormId,
}) => {
  const [selectedForm, setSelectedForm] = useState(null);
  const [selectedSection, setSelectedSection] = useState([]);

  const [roleList, setRoleList] = useState([]);
  const [formList, setFormList] = useState([]);
  const [sectionList, setSectionList] = useState([]);
  const [endDate, setEndDate] = useState("");
  const [formDataMap, setFormDataMap] = useState([]);
  const [popupData, setPopupData] = useState(null);
  // const [selectedRole, setSelectedRole] = useState([]);

  useEffect(() => {
    const fetchStandardSurveyForms = async () => {
      try {
        let response;
        if (assignedFormType === "standard") {
          response = await getApi({
            apiUrl: API_URLS.GET_STANDARD_FORM_BY_PROJECTID(projectId),
          });
        } else {
          response = await getApi({
            apiUrl: API_URLS.GET_CUSTOM_FORM_BY_PROJECTID(projectId),
            // headers: { client: clientId },
          });
        }
        if (response?.success) {
          const allForms = response.data;
          setFormDataMap(allForms);
          if (assignedFormType === "standard") {
            const list = allForms.map((formData) => ({
              label: formData.title,
              value: formData.title.toLowerCase(),
              formId: formData._id,
            }));
            setFormList(list);
          } else {
            const list = allForms.map((formData) => ({
              label: formData.title,
              value: formData.title.toLowerCase(),
              formId: formData._id,
            }));
            setFormList(list);
          }
        }
      } catch (error) {
        console.error("Error fetching standard survey forms", error);
      }
    };

    fetchStandardSurveyForms();
  }, [projectId]);

  useEffect(() => {
    if (assignedFormType !== "standard") {
      setRoleList([
        { label: "Sub Admin", value: "sub_admin" },
        { label: "Location User", value: "location_user" },
        { label: "Employee", value: "employee" },
        { label: "Vendor", value: "vendor" },
      ]);
    }
  }, [assignedFormType]);

  const fetchSection = useCallback(async (formId) => {
    try {
      const response = await getApi({
        apiUrl:
          assignedFormType === "standard"
            ? API_URLS.GET_SECTION_SUBSECTION_BY_FORMID(formId)
            : API_URLS.GET_CUSTOM_SECTIONS_BY_FORMID(formId),
        headers: { client: clientId },
      });
      if (assignedFormType === "standard") {
        if (response?.success && Array.isArray(response.data)) {
          const sectionMap = new Map();

          response.data.forEach((item) => {
            const section = item.section;
            if (section && !sectionMap.has(section._id)) {
              sectionMap.set(section._id, {
                label: section.name,
                value: section._id,
                sectionId: section._id,
              });
            }
          });

          const sectionOptions = Array.from(sectionMap.values());

          setSectionList([
            { label: "Select ALL SECTION", value: "all_section" },
            ...sectionOptions,
          ]);
        }
      } else {
        if (response.success) {
          const sectionOptions = response.data.custom.sections.map(
            (item, index) => ({
              label: item.name,
              value: item._id,
              sectionId: item._id,
            })
          );
          setSectionList([
            { label: "Select ALL SECTION", value: "all_section" },
            ...sectionOptions,
          ]);
        }
      }
    } catch (error) {
      console.error("Error fetching sections", error);
    }
  }, []);

  const handleSelectForm = useCallback(
    (value) => {
      const selected = formList.find((form) => form.value === value);
      setSelectedForm(value);
      setSelectedSection([]);
      setSelectedRole(null);

      if (selected?.formId) {
        setFormId(selected.formId);
        fetchSection(selected.formId);
      }

      // Update for correct structure
      if (assignedFormType === "standard") {
        const selectedFormData = formDataMap.find(
          (form) => form.title.toLowerCase() === value
        );

        const roles = selectedFormData?.role_type || [];
        if (assignedFormType === "standard") {
          setRoleList(
            roles.map((role) => ({
              label: role,
              value: role.toLowerCase(),
            }))
          );
        } else if (assignedFormType === "dynamic") {
          setRoleList([
            { label: "Sub Admin", value: "sub_admin" },
            { label: "Location User", value: "location_user" },
            { label: "Employee", value: "employee" },
            { label: "Vendor", value: "vendor" },
          ]);
        }
      }
    },

    [formList, fetchSection, formDataMap]
  );

  const handleSelectSection = useCallback(
    (value) => {
      if (value.includes("all_section")) {
        setSelectedSection(sectionList.map((section) => section.value));
      } else {
        setSelectedSection(value);
      }
    },
    [sectionList]
  );

  const postAssignedForm = useCallback(
    async (formData) => {
      try {
        const response = await postApi(
          {
            apiUrl:
              assignedFormType === "standard"
                ? API_URLS.CREATE_STANDARD_ASSIGN_FORM
                : API_URLS.CREATE_DYNAMIC_ASSIGN_FORM,
            data: formData,
            headers: { client: clientId },
          },
          true
        );
        if (response.success) {
          setPopupData({
            type: "success",
            title: "Assined SuccessFully",
            message:
              assignedFormType === "standard"
                ? "Standard Form Assigned Successfully"
                : "Dynamic Form Assigned Successfully",
          });
        } else {
          setPopupData({
            type: "warning",
            title: "Failed",
            message: response.message || "Form assignment failed",
          });
        }
        // toast.success(`form Assigned successfully`);
      } catch (error) {
        console.error("Error assigning form", error);
        setPopupData({
          type: "error",
          title: "Error",
          message: error.message || "Error assigning form",
        });
      } finally {
        setTimeout(() => setPopupData(null), 2000); // auto close
      }
    },
    [assignedFormType]
  );

  const handleApply = useCallback(() => {
    if (!selectedRows || selectedRows.length === 0) {
      setPopupData({
        type: "warning",
        title: "Warning",
        message: "Please select at least one user",
      });
      setTimeout(() => setPopupData(null), 2000);
      return;
    }
    if (!endDate) {
      setPopupData({
        type: "warning",
        title: "Warning",
        message: "Please select end date",
      });
      setTimeout(() => setPopupData(null), 2000);
      return;
    }

    const currentDate = moment().format("YYYY-MM-DD");

    const newAssignedFormData = {
      projectId: projectId,
      templateId: formId,
      user: selectedRows.map((user) => ({
        id: user.key,
        sections: selectedSection.map(
          (sectionValue) =>
            sectionList.find((section) => section.value === sectionValue)
              ?.sectionId
        ),
        endDate,
        allotmentDate: currentDate,
        status: "Assigned",
      })),
      role: selectedRole?.toLowerCase(),
    };
    // console.log("Data present :", newAssignedFormData);
    postAssignedForm(newAssignedFormData);
  }, [
    selectedRows,
    selectedSection,
    sectionList,
    projectId,
    formId,
    endDate,
    postAssignedForm,
    selectedRole,
  ]);

  const handleReset = useCallback(() => {
    setSelectedForm(null);
    setSelectedSection([]);
    setSelectedRole(null);
    setEndDate("");
    setRoleList([]);
    setFormId(null);
    setSectionList([]);
  }, []);

  return (
    <div>
      <div className="flex gap-10 items-start">
        <div className="w-full">
          <h4 className="text-[#088F8F] text-sm mt-2">SELECT FORM</h4>
          <CustomSelect
            options={formList}
            mode="single"
            placeholder="--None--"
            height="40px"
            value={selectedForm}
            onChange={handleSelectForm}
            loading={formList.length === 0}
          />
          <div className="my-2">
            <h4 className="text-[#088F8F] text-sm mt-2">SELECT ROLE</h4>
            <CustomSelect
              options={roleList}
              mode="single"
              placeholder="--None--"
              height="40px"
              value={selectedRole}
              onChange={(value) => {
                setSelectedRole(value);
              }}
              loading={roleList.length === 0}
              disabled={!selectedForm}
            />
          </div>
        </div>
        <div className="w-full">
          <h4 className="text-[#088F8F] text-sm mt-2">SELECT SECTION</h4>
          <CustomSelect
            options={sectionList}
            mode="multiple"
            height="40px"
            placeholder="Select Section"
            value={selectedSection}
            onChange={handleSelectSection}
            disabled={!selectedForm}
            loading={sectionList.length === 0}
          />
          <div className="my-2">
            <h4 className="text-[#088F8F] text-sm mt-2">End Date</h4>
            <CustomDatePicker
              value={endDate}
              onChange={(date) => {
                setEndDate(date);
              }}
              placeholder="Select End Date"
            />
          </div>
        </div>
      </div>
      <div className="flex justify-end gap-5">
        <Button
          type="primary"
          style={{
            color: "#088F8F",
            background: "#e7fefe",
            border: "2px solid #088F8F",
            height: "50px",
            width: "120px",
            borderRadius: "10px",
          }}
          className="text-[16px]"
          onClick={handleReset}
        >
          Reset
        </Button>
        <CustomButton
          buttonType="primary"
          variant="ok"
          buttonText="Apply"
          className="text-[16px] w-36 h-12"
          onClick={handleApply}
          disabled={!selectedForm || selectedSection.length === 0}
          // disabled={
          //   !selectedForm ||
          //   !selectedRole ||
          //   selectedSection.length === 0 ||
          //   !endDate ||
          //   selectedRows.length === 0
          // }
        />
      </div>
      {/* {formAssignedSuccess && (
        <SuccessDailogBox
          onOpen={formAssignedSuccess}
          onClose={() => setFormAssignedSuccess(false)}
          successMessage={"Form Assigned Successfully"}
          popuptype="success"
        />
      )} */}
      .
      {popupData && (
        <div className="fixed inset-0 bg-black/30 z-50 flex items-center justify-center">
          <PopupCard
            type={popupData.type}
            title={popupData.title}
            message={popupData.message}
          />
        </div>
      )}
    </div>
  );
};

export default AssignedForm;
